<template>
	<div class="roundup-toggle">
		<input
			:checked="checked === null"
			@change="$emit('input', $event.target.value)"
			type="checkbox"
			:id="key"
		/>
		<label :for="key"></label>
	</div>
</template>

<script>
export default {
	name: 'roundup-toggle',
	props: ['checked'],
	computed: {
		key() {
			return 'toggle-' + this.makeid()
		}
	},
	methods: {
		makeid() {
			var text = ''
			var possible =
				'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
			for (var i = 0; i < 8; i++) {
				text += possible.charAt(
					Math.floor(Math.random() * possible.length)
				)
			}
			return text
		}
	}
}
</script>

<style lang="scss">
.roundup-toggle {
	position: relative;
	input[type='checkbox'] {
		height: 0;
		width: 0;
		visibility: hidden;
		position: absolute;
	}
	label {
		cursor: pointer;
		text-indent: -9999px;
		width: 44px;
		height: 26px;
		background: #808080;
		display: block;
		border-radius: 13px;
		position: relative;
		&:after {
			content: '';
			position: absolute;
			top: 1px;
			left: 1px;
			width: 24px;
			height: 24px;
			background: #fff;
			border-radius: 12px;
			transition: 0.3s;
		}
	}
	input {
		&:checked {
			& + label {
				background: #4c7dff;
				&:after {
					left: calc(100% - 1px);
					transform: translateX(-100%);
				}
			}
		}
	}
}
</style>
